import { createContext, useCallback, useContext, useState } from "react";
import BookingModal from "../components/BookingModal";

const BookingContext = createContext(null);
export const useBooking = () => useContext(BookingContext);

export const BookingProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, listing: null, service: "tour" });

  const openBooking = useCallback((opts = {}) => {
    setState({ open: true, listing: opts.listing || null, service: opts.service || "tour" });
  }, []);
  const closeBooking = useCallback(() => setState((s) => ({ ...s, open: false })), []);

  return (
    <BookingContext.Provider value={{ ...state, openBooking, closeBooking }}>
      {children}
      <BookingModal />
    </BookingContext.Provider>
  );
};
